import api from '@/api/axios';
import { PrimaryButton } from '@/components/Button';
import { Text } from '@/components/Text';
import { TextLink } from '@/components/TextLink';
import { AnonymousStackParamList } from '@/navigations/AnonymousStack';
import { StackScreenProps } from '@react-navigation/stack';
import { useState } from 'react';
import { View } from 'react-native';
import { LoginLayout } from './Layout';

export function ReactivateAccount({
  route,
  navigation,
}: StackScreenProps<AnonymousStackParamList, 'ReactivateAccount'>) {
  const reactivationToken = route.params.reactivationToken;
  const [isRequested, setIsRequested] = useState(false);

  function handlePress() {
    if (isRequested) return navigation.navigate('Login');
    api
      .post(`/api/users/reactivation/${reactivationToken}`)
      .then(() => {
        setIsRequested(true);
      })
      .catch(() => {});
  }

  return (
    <LoginLayout>
      <View>
        {isRequested ? (
          <Text className="text-xl text-center mb-6">
            Aktivierung wurde angefordert
          </Text>
        ) : (
          <Text className="text-xl text-center mb-6">
            Ihr Benutzerkonto wurde deaktiviert
          </Text>
        )}

        {isRequested ? (
          <Text className="text-lg mb-2">
            Ihre Anfrage wurde gesendet. Unser Kundendienst wird sich sofort
            darum kümmern. Sie erhalten eine E–Mail, sobald Ihr Benutzerkonto
            wieder aktiviert ist.
          </Text>
        ) : (
          <Text className="text-lg mb-2">
            Unser Kundenservice kann Ihr Benutzerkonto wieder aktivieren. Sie
            können die Aktivierung telefonisch unter{' '}
            <TextLink href="tel:+49089248864440">
              +49 (0)89 24 886 4440
            </TextLink>{' '}
            anfordern oder direkt eine Anfrage an uns senden.
          </Text>
        )}

        <PrimaryButton
          label={'Benutzerkonto erneut aktivieren'}
          onPress={handlePress}
        />

        <Text
          className="text-green-neolexon text-center mt-4"
          onPress={() => navigation.navigate('Login')}
        >
          Zurück zum Login
        </Text>
      </View>
    </LoginLayout>
  );
}
